// extracted by mini-css-extract-plugin
module.exports = {"landing_text_title":"styles_landing_text_title__39UWi","team_text_title":"styles_team_text_title__ZYrt4","loop_text_wrapper":"styles_loop_text_wrapper__4hnWP"};